<template>
    <div class="structure-block-image-text-row grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 h-fit">
        <div class="flex flex-col gap-4">
            <div class="aspect-square">
                <component :is="leftImageComponent" :content="leftImageSlot" />
            </div>
            <component :is="leftTextComponent" :content="leftTextSlot" />
        </div>

        <div class="flex flex-col gap-4">
            <div class="aspect-square">
                <component :is="centerImageComponent" :content="centerImageSlot" />
            </div>
            <component :is="centerTextComponent" :content="centerTextSlot" />
        </div>

        <div class="flex flex-col gap-4">
            <div class="aspect-square">
                <component :is="rightImageComponent" :content="rightImageSlot" />
            </div>
            <component :is="rightTextComponent" :content="rightTextSlot" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblSlot } from '@/utils/types'
import { hblToUpperCamelCase } from '@/utils/helper'

const props = defineProps<{
    content: HblSlot[]
}>()

const leftImageSlot = computed(() => {
    return props.content.find(item => item.position === 'left-image')
})

const centerImageSlot = computed(() => {
    return props.content.find(item => item.position === 'center-image')
})

const rightImageSlot = computed(() => {
    return props.content.find(item => item.position === 'right-image')
})

const leftTextSlot = computed(() => {
    return props.content.find(item => item.position === 'left-text')
})

const centerTextSlot = computed(() => {
    return props.content.find(item => item.position === 'center-text')
})

const rightTextSlot = computed(() => {
    return props.content.find(item => item.position === 'right-text')
})

const leftImageComponent = computed(() => {
    if (!leftImageSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftImageSlot.value.type)}`
})

const centerImageComponent = computed(() => {
    if (!centerImageSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerImageSlot.value.type)}`
})

const rightImageComponent = computed(() => {
    if (!rightImageSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightImageSlot.value.type)}`
})

const leftTextComponent = computed(() => {
    if (!leftTextSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftTextSlot.value.type)}`
})

const centerTextComponent = computed(() => {
    if (!centerTextSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerTextSlot.value.type)}`
})

const rightTextComponent = computed(() => {
    if (!rightTextSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightTextSlot.value.type)}`
})
</script>
